export const storeLastTransactions = (state, transactions) => {
  state.lastTransactions = [...transactions];
};

export const storePayoutAmount = (state, amount) => {
  state.payoutAmount = amount;
};
